<div class="page-utils webview-hide">
    <div class="row">
        <div class="col col-12 sm-col-8 back-links">
            <nav role="navigation" [attr.aria-label]="'event view.breadcrumb' | translate">
                <ul class="breadcrumbs" [attr.aria-label]="'event view.breadcrumb' | translate">
                    <li>
                        <span>
                            <a [routerLink]="breadcrumbLink">
                                {{ 'events.Career Fairs' | translate }}
                            </a>
                            <span class="bc-sep space-right-xs space-left-xs">/</span>
                        </span>
                    </li>
                    <li>
                        <span class="current_path" [attr.aria-current]="'page'">
                            {{ event.label }}
                        </span>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</div>

<div class="page-title-wrapper"></div>

<div class="page-main">
    <div class="floating_content">
        <div class="content-container-inner">
            <cf-event-view-header
                class="flexbox flex-column"
                [headerData]="headerData"
                [buttonsData]="actionButtons"
                (buttonClick)="onButtonClick($event)"
            >
            </cf-event-view-header>

            <div class="form-layout form-readonly">
                <div class="form-container">
                    <div class="form-col no-padding">
                        <nav>
                            <tab [tabData]="tabData"></tab>
                        </nav>

                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<footer page-footer role="contentinfo"></footer>
<size-detector id="main-layout"></size-detector>
